export default __webpack_public_path__ + "static/media/youtube.55fbf3f2.svg";